module.exports = __webpack_public_path__ + "img/down.65752c9b.svg";